import { render } from "./userStudent.vue?vue&type=template&id=ea4b8a26&scoped=true"
import script from "./userStudent.vue?vue&type=script&lang=js"
export * from "./userStudent.vue?vue&type=script&lang=js"

import "./userStudent.vue?vue&type=style&index=0&id=ea4b8a26&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4b8a26"]])

export default __exports__